import React from 'react';
import dashStyle from './style.module.css';

const Landing = () => {
  return (
    <div className={dashStyle.landing}>
      <p>Welcome to Home Manager</p>
      <p>Go to Home page.</p>
    </div>
  )
}

export default Landing;
